import React from 'react';
import Modal from '@material-ui/core/Modal';
import Button from '@material-ui/core/Button';
import { withStyles, WithStyles } from '@material-ui/core/styles';
import { Theme } from "@material-ui/core/styles";
import Typography from '@material-ui/core/Typography';
import zIndex from '@material-ui/core/styles/zIndex';

class Loader extends React.Component<WithStyles<typeof styles>> {

  //PM 2021-06-11
  render() {
    const classes = this.props.classes;

    return (   
        <div style={{  }} className={classes.alert}>
          <img width='100px' height='100px' src={require('./loaderNew.gif').default} ></img>
        </div>
    );

  }
}

const styles = (theme: Theme) => ({

  alert: {
    top: '50%',
    left: '50%',
    //right: 'auto',
   // bottom: 'auto',
    //marginRight: '-50%',
    //transform: 'translate(-50%, -50%)',
    //background : '#ffffff',
    //padding: theme.spacing(2, 4, 3),
    //outline: 0
    padding: "20px",
    margin: '0px 0 0 -70px',
    position: 'relative' as "relative",
    width: "100px",
  },
  body: {
    fontSize: "12px",
    fontFamily: "\"Arial\", \"Helvetica\", sans-serif",
    lineHeight: "20px",
    fontWeight: theme.typography.body2.fontWeight,
    color: "#555"
  }
});


export default withStyles(styles)(Loader);